import { computed, DestroyRef, inject, Injectable, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationSkipped, NavigationStart, Router } from '@angular/router';
import { LoadingService } from './loading.service';

/** Comparte la visibilidad del indicador y el bloqueo del contenido. */
@Injectable({ providedIn: 'root' })
export class LoadingUiService {
    private readonly loading = inject(LoadingService);
    private readonly router = inject(Router);
    private readonly currentUrl = signal(this.router.url);
    private readonly pendingUrl = signal<string | null>(null);
    private readonly enabled = computed(() => !this.isLoginUrl(this.currentUrl()) && !this.isLoginUrl(this.pendingUrl()));

    readonly isBlocking = computed(() => this.enabled() && this.loading.isBlocking());
    readonly isBlockingVisible = computed(() => this.isBlocking() && this.loading.isBlockingVisible());
    readonly isProgressVisible = computed(() => this.enabled() && this.loading.isProgressVisible() && !this.loading.isBlocking());

    constructor() {
        this.router.events.pipe(takeUntilDestroyed(inject(DestroyRef))).subscribe((event) => {
            if (event instanceof NavigationStart) {
                this.pendingUrl.set(event.url);
            } else if (event instanceof NavigationEnd) {
                this.currentUrl.set(event.urlAfterRedirects);
                this.pendingUrl.set(null);
            } else if (event instanceof NavigationCancel || event instanceof NavigationError || event instanceof NavigationSkipped) {
                this.currentUrl.set(this.router.url);
                this.pendingUrl.set(null);
            }
        });
    }

    private isLoginUrl(url: string | null): boolean {
        return /^\/auth\/login(?:[/?#;]|$)/.test(url ?? '');
    }
}
